import type { StateCreator } from 'zustand';
import type { AppState } from '../types';
import { updateActiveProfile } from '../helpers';
import { DEFAULT_GAMIFICATION_STATE } from '../../gamification/types';
import type { GamificationSettings, GamificationState } from '../../gamification/types';

export interface GamificationSlice {
    gamification: GamificationState;
    setGamificationEnabled: (enabled: boolean) => void;
    setGamificationSettings: (settings: Partial<GamificationSettings>) => void;
    updateGamificationState: (updates: Partial<GamificationState>) => void;
}

export const createGamificationSlice: StateCreator<AppState, [], [], GamificationSlice> = (set) => ({
    gamification: { ...DEFAULT_GAMIFICATION_STATE },

    setGamificationEnabled: (enabled) => set((state) => {
        const newGamification = { ...state.gamification, enabled };
        return {
            gamification: newGamification,
            ...(updateActiveProfile(state, { gamification: newGamification }) as Partial<AppState>),
        };
    }),

    setGamificationSettings: (settings) => set((state) => {
        const newGamification = {
            ...state.gamification,
            settings: { ...state.gamification.settings, ...settings }
        };
        return {
            gamification: newGamification,
            ...(updateActiveProfile(state, { gamification: newGamification }) as Partial<AppState>),
        };
    }),

    updateGamificationState: (updates) => set((state) => {
        const newGamification = { ...state.gamification, ...updates };
        return {
            gamification: newGamification,
            ...(updateActiveProfile(state, { gamification: newGamification }) as Partial<AppState>),
        };
    }),
});
